import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { ICE_DRIFT } from '../config/services'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'

const id = 'IceDrift'

export const vectorUrl = ({ idToken, timeIso }) =>
  `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&request=GetMap&version=1.1.1&layers=coresight2%3AIceDrift&styles=&format=application%2Fx-protobuf;type=mapbox-vector&transparent=true&tiled=true&height=512&width=512&srs=EPSG%3A3857&TIME=${encodeURIComponent(
    timeIso
  )}&BBOX={bbox-epsg-3857}&token=${idToken}`

export class IceDrift extends Component {
  shouldComponentUpdate (nextProps) {
    if (nextProps.paint !== this.props.paint) {
      return false
    } else if (nextProps === this.props) {
      return false
    }
    return true
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentWillReceiveProps (props) {
    const { paint, layout, before, layerOptions } = this.props
    const { map } = this.context

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        try {
          map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
        } catch (error) {
          console.log(error)
        }
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (
      props.layerOptions &&
      layerOptions &&
      !isEqual(props.layerOptions.filter, layerOptions.filter)
    ) {
      map.setFilter(id, props.layerOptions.filter)
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  render () {
    const { idToken, layerRendered, paint, time } = this.props
    const visible = layerRendered
    const timeIso = time ? new Date(time).toISOString() : ''
    const rasterSource = {
      type: 'raster',
      tiles: [ICE_DRIFT({ idToken, timeIso })],
      tileSize: 256
    }
    const vectorSource = {
      type: 'vector',
      tiles: [vectorUrl({ idToken, timeIso })],
      tileSize: 512,
      minZoom: 1,
      maxZoom: 22
    }

    if (!visible) {
      return null
    }

    return (
      <div>
        <Source id={id} tileJsonSource={rasterSource} />
        {/* <Source id={`${id}-vector`} tileJsonSource={vectorSource} /> */}
        <Layer
          type='raster'
          id={id}
          sourceId={id}
          layout={{ visibility: visible ? 'visible' : 'none' }}
          paint={paint}
        />
        {/* <Layer */}
      {/*     type='line' */}
      {/*     id={`${id}-line`} */}
      {/*     sourceId={`${id}-vector`} */}
      {/*     sourceLayer={'IceDrift'} */}
      {/* paint={{ */}
      {/*   'line-color': 'blue', */}
      {/*   'line-width': 3 */}
      {/* }} */}
      {/*   /> */}
      {/*   <Layer */}
      {/*     type='symbol' */}
      {/*     id={`${id}-arrow`} */}
      {/*     sourceId={`${id}-vector`} */}
      {/*     sourceLayer={'IceDrift'} */}
      {/*     layout={{ */}
      {/*       'text-field': '^', */}
      {/*       'symbol-placement': 'line-center', */}
      {/*       'symbol-spacing': 1, */}
      {/*       'text-size': 36, */}
      {/*       'text-keep-upright': false, */}
      {/*       'text-rotation-alignment': 'map', */}
      {/*       'text-anchor': 'top', */}
      {/*       'text-max-angle': 360, */}
      {/*       'text-rotate': 90, */}
      {/*       'text-padding': 0, */}
      {/*       'text-allow-overlap': true, */}
      {/*       'text-ignore-placement': true, */}
      {/*       'text-justify': 'right', */}
      {/*       'text-offset': [0, 0.1] */}
      {/*     }} */}
      {/* paint={{ */}
      {/*       'text-color': [ */}
      {/*         'interpolate', */}
      {/*         ['linear'], */}
      {/*         ['number', ['get', 'r']], */}
      {/*         0.3, '#d7191c', */}
      {/*         1, '#2c84ba' */}
      {/*       ], */}
      {/* }} */}
      {/*   /> */}
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(state, id),
      paint: getPaint(state, id),
      time: state.layer.times.IceDrift || undefined
    }
  }
  return mapStateToProps
}

export default connect(makeMapStateToProps(), null)(IceDrift)



// WEBPACK FOOTER //
// ./src/layers/IceDrift.js